import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import useStyles from './useStyles';

export type Props = {
  /** Element to which the tooltip is added */
  container: HTMLElement;
} & React.HTMLAttributes<HTMLSpanElement>;

function Tooltip({ container, className, id = '' }: Props): React.ReactElement {
  /** container center position to display tooltip */
  const center = container.offsetWidth / 2;
  const { tooltip, tooltipBody } = useStyles({ center });

  return ReactDOM.createPortal(
    <span role="tooltip" id={id} className={classNames(tooltip, className)}>
      <span className={tooltipBody}>{container.dataset.tooltip}</span>
    </span>,
    container
  );
}

export default Tooltip;
